module.exports = __webpack_public_path__ + "img/customer_bg.0867c387.svg";